(() => {
    const $siteHeader = document.querySelector('.site-header');
    const $siteMenuModal = document.querySelector('.site-menu-modal');

    let lastScrollPos = window.scrollY;

    const initSiteHeader = () => {
        const $firstBlock = document.querySelector('.block');

        if (!$siteHeader) return;

        if ($firstBlock && $firstBlock.classList.contains('background-color-black')) {
            $siteHeader.classList.add('site-header--white');
        }

        setTimeout(() => {
            $siteHeader.classList.add('site-header--initiated');
        }, 300);
    };

    const initSiteHeaderBackground = () => {
        if (!$siteHeader) return;

        if (window.scrollY === 0) {
            $siteHeader.classList.remove('site-header--scrolled');
        } else {
            $siteHeader.classList.add('site-header--scrolled');
        }
    };

    const toggleSiteHeader = () => {
        if (window.scrollY > lastScrollPos && window.scrollY > 100) {
            $siteHeader.classList.add('site-header--hide');

            lastScrollPos = window.scrollY;
        };
        
        if (window.scrollY <= 100 || window.scrollY < lastScrollPos - 100) {
            $siteHeader.classList.remove('site-header--hide');

            lastScrollPos = window.scrollY;
        };
    };

    if ($siteHeader && $siteMenuModal) {
        $siteMenuModal.addEventListener('modalopen', () => {
            $siteHeader.classList.add('site-header--site-menu-modal-open');
        });

        $siteMenuModal.addEventListener('modalclose', () => {
            $siteHeader.classList.remove('site-header--site-menu-modal-open');
        });
    }

    window.addEventListener('scroll', () => {
        toggleSiteHeader();
        initSiteHeaderBackground();
    });

    initSiteHeader();
    initSiteHeaderBackground();
})();
